import {Button} from '@phonectas/unifon-ui-kit';
import sc from 'styled-components';

export const StyledCancelButton = sc(Button)`
    &:hover {
        background-color: #F7F2ED;
    }
`;